module.exports = __webpack_public_path__ + "img/Frente-7-00 off.b7ec62cc.png";